import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { Task } from '../../../../../shared/models/task';
import { enumTaskSelection, TaskService } from '../../../../../shared/services/task.service';
import { ListFilterItem, ListSortOrderItem } from '../../../../../shared/services/listSortAndFilterHelpers';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { UserService } from 'app/shared/services/user.service';
import { environment } from 'environments/environment';
import { IParentEntity } from 'app/shared/interfaces/entity';
import { User } from 'app/shared/models/user';

@Component({
    selector: 'fuse-task-main-sidenav',
    templateUrl: './main-sidenav.component.html',
    styleUrls: ['./main-sidenav.component.scss'],
    animations: fuseAnimations,
})
export class FuseTaskMainSidenavComponent implements OnInit, OnDestroy {

    filters: ListFilterItem[];

    onApplyFilter: Subscription;
    onCurrentUserChanged: Subscription;

    constructor(public taskService: TaskService, private router: Router, private userService: UserService) {
    }

    @Input() title: string;
    // tslint:disable-next-line: no-inferrable-types
    @Input() userReadOnly: boolean = false;
    @Input() parentEntity: IParentEntity = null;

    ShowAddButton: boolean = false;

    ngOnInit() {
        this.filters = this.taskService.getFilters();

        this.onApplyFilter = this.taskService.onApplyFilter.subscribe((_) => {
            this.filters = this.taskService.getFilters();
            this.ShowAddButton = !(environment.limitAccessToSubjectsByOrg === true && this.userService.getCurrentUser().isAdmin === true);
        });

        this.onCurrentUserChanged = this.userService.onCurrentUserChanged.subscribe(user => {
            this.ShowAddButton = !(environment.limitAccessToSubjectsByOrg === true && user && user.isAdmin === true);
        });
    }

    ngOnDestroy() {
        this.onApplyFilter?.unsubscribe();
        this.onCurrentUserChanged?.unsubscribe();
    }

    btnApplyFilter(filter: ListFilterItem) {
        let route = '/tasks';
        switch (this.taskService.taskSelection) {
            case enumTaskSelection.MyTasks:
                route = route + '/my';
                break;
            case enumTaskSelection.SubjectTasks:
                route = route + '/subject';
                break;
            case enumTaskSelection.FilterByUserTasks:
                route = route + '/users';
                break;
            case enumTaskSelection.CreatedTasks:
                route = route + '/created';
                break;
            default:
                route = route + '/all';
                break;
        }
        route = route + '/' + filter.title.toLowerCase();
        this.router.navigateByUrl(route);
        this.taskService.onApplyFilter.next(filter);
    }

    btnApplySortOrder(sortOrder: ListSortOrderItem) {
        this.taskService.onApplySortOrder.next(sortOrder);
    }

    newTask() {
        var task: Task = new Task();

        this.userService.getAllData().subscribe((x: User[]) => {
            task.organisationId = this.userService.getCurrentUser().organisationId;
            this.taskService.onNewTaskClicked.next(task);
        });
    }
}
